import React, { useState, useEffect } from "react";
import { TextField, MenuItem } from "@mui/material";
import axios from "axios";

// const active_fields_url =
//   "https://2x6pwxnrll.execute-api.us-east-1.amazonaws.com/Dev/get_active_fields";
//   const get_operator_url =
//   "https://2x6pwxnrll.execute-api.us-east-1.amazonaws.com/Dev/get_operator";

function SourceInputBox({
  inputField,
  handleChangeInput,
  setInputFields,
  allFields,
  setAllFields,
  currentId,
  operator,
  setOperator,
  activeSourceFields,
  setActiveSourceFields,
  inputFields,
  isEditClickedonViewRules,
  source1_id,
  attribute1_id,
  source2_id,
  attribute2_id,
  // activeFields,
  // setActiveFields,
  // activeFields2,
  // setActiveFields2,
  active_fields_url,
  get_operator_url,
  definedValue,
  setDefinedValue,
}) {
  // const [activeSourceFields, setActiveSourceFields] = useState([]);

  console.log("-================;;;;;;;;;", source1_id, attribute1_id);

  const [activeFields, setActiveFields] = useState([]);
  const [activeFields2, setActiveFields2] = useState([]);
  const [selectedSource, setSelectedSource] = useState("");
  const [selectedSource2, setSelectedSource2] = useState("");
  // const [allFields, setAllFields] = useState([]);
  // const [operator, setOperator] = useState([]);
  const [definedValue1, setDefinedValue1] = useState(false);
  const [definedValue2, setDefinedValue2] = useState(false);
  const [newInputField, setnewInputField] = useState();
  const valuesAndIds = {};

  useEffect(() => {
    axios.post(get_operator_url).then((res) => {
      setOperator(res.data.body);
      // console.log(res.data.body);
    });
  }, [inputField.id]);

  const findIdAttribute = (data, itemName, Source_Name) => {
    const value =
      data.length > 0
        ? data?.filter(
            (item) =>
              item.SourceName_CR == Source_Name && item.FieldName_CR == itemName
          )?.[0]["Field_ID"]
        : undefined;

    return value;
  };

  const findIdOperator = (data, operatorSymbol) => {
    return data.length > 0
      ? data?.filter((item) => item.Operator_CR == operatorSymbol)?.[0][
          "Operator_ID"
        ]
      : undefined;
  };

  const findIdSource = (data, sourceName) => {
    const value =
      data.length > 0
        ? data?.filter((item) => item.SourceName_CR == sourceName)?.[0][
            "Source_ID"
          ]
        : undefined;

    // console.log("Source vlaue------------->", data);
    return value;
  };

  useEffect(() => {
    axios.post(active_fields_url).then((res) => {
      const uniqValues = [
        ...new Map(
          res.data.body.map((item) => [item["SourceName_CR"], item])
        ).values(),
        // {
        //   Source_ID: "Defined_Value",
        //   SourceName_CR: "Defined Value",
        // },
      ];

      // console.log("uniqValues");
      // console.log(uniqValues);
      setActiveSourceFields(uniqValues);
      setAllFields(res.data.body);

      // const dataWithString = res.data.body.map((d)=>{d.Field_ID = d.Field_ID.toString(); return d;})
      // const dataWithString = res.data.body.map(e => ({...e, Field_ID: e.Field_ID + '', Source_ID: e.Source_ID + '' }));
      // setAllFields(dataWithString);
      // console.log(dataWithString);
    });
  }, [inputField.id]);

  useEffect(() => {
    const newStates = allFields.filter(
      ({ Source_ID }) => Source_ID === selectedSource
    );
    // console.log(selectedSource, newStates);
    setActiveFields(newStates);
  }, [selectedSource]);

  useEffect(() => {
    const newStates = allFields.filter(
      ({ Source_ID }) => Source_ID === selectedSource2
    );
    // console.log(selectedSource2, newStates);
    setActiveFields2(newStates);
  }, [selectedSource2]);

  // useEffect(() => {
  //   const newStates = allFields.filter(
  //     ({ Source_ID }) => Source_ID === definedValue1
  //   );
  //   setDefinedValue1(newStates);
  // },[definedValue1]);
  useEffect(() => {
    const newInputFields = Object.keys(inputField).some((item) =>
      item.toLowerCase().includes("_id")
    )
      ? inputField
      : {
          id: inputField.id,
          source1_id: findIdSource(activeSourceFields, inputField.source1_name),
          attribute1_id: findIdAttribute(
            allFields,
            inputField.attribute1_name,
            inputField.source1_name
          ),
          operator_id: findIdOperator(operator, inputField.operator),
          relation_type: inputField.relation_type,
          source2_id: findIdSource(activeSourceFields, inputField.source2_name),
          attribute2_id: findIdAttribute(
            allFields,
            inputField.attribute2_name,
            inputField.source2_name
          ),
        };
    // setnewInputField(inputFields);

    console.log("newInputfields----------->", newInputFields);
    setSelectedSource(newInputFields.source1_id);
    setSelectedSource2(newInputFields.source2_id);
    setInputFields((prevV) => {
      return prevV.map((obj) => {
        if (obj.id === currentId) {
          // Replace object with newObject
          return newInputFields;
        } else {
          // Keep the current object unchanged
          return obj;
        }
      });
    });
  }, [
    inputField.source1_id,
    inputField.attribute1_id,
    inputField.operator_id,
    inputField.source2_id,
    inputField.attribute2_id,
    inputField.id,
    selectedSource,
    selectedSource2,
  ]);

  console.log(inputFields);
  if (inputField.source1_id == undefined && inputField.source2_id == undefined)
    return null;

  return (
    <>
      <TextField
        className="ruleContainer"
        select
        name="source1_id"
        label="Source"
        variant="outlined"
        size="small"
        // value={inputField.source1_id}
        value={source1_id}
        onChange={(event) => {
          console.log(source1_id);
          setSelectedSource(event.target.value);
          setDefinedValue1(event.target.value);
          handleChangeInput(inputField.id, event);
        }}
        onClick={(e) => console.log("clicked!!!!!!!!!")}
      >
        {activeSourceFields
          ? activeSourceFields.map((opt) => (
              <MenuItem
                key={opt.Source_ID}
                value={opt.Source_ID}
                onChange={(value) => setSelectedSource(value)}
              >
                {opt.SourceName_CR}
              </MenuItem>
            ))
          : ""}
      </TextField>

      {definedValue ? (
        <TextField
          className="ruleContainer"
          name="attribute1_id"
          label="Defined Value"
          size="small"
          // value={inputField.attribute1_id}
          value={attribute1_id}
          onChange={(event) => handleChangeInput(inputField.id, event)}
        />
      ) : (
        <TextField
          className="ruleContainer"
          select
          name="attribute1_id"
          label="Attribute"
          variant="outlined"
          size="small"
          // value={inputField.attribute1_id}
          value={attribute1_id}
          onChange={(event) => handleChangeInput(inputField.id, event)}
        >
          {activeFields
            ? activeFields.map((opt) => (
                <MenuItem key={opt.Field_ID} value={opt.Field_ID}>
                  {opt.FieldName_CR}
                </MenuItem>
              ))
            : ""}
        </TextField>
      )}

      <TextField
        className="ruleContainer"
        select
        name="operator_id"
        label="Operation"
        variant="outlined"
        size="small"
        value={inputField.operator_id}
        onChange={(event) => handleChangeInput(inputField.id, event)}
      >
        {operator
          ? operator.map((opt) => (
              <MenuItem key={opt.Operator_ID} value={opt.Operator_ID}>
                {opt.Operator_CR}
              </MenuItem>
            ))
          : ""}
      </TextField>

      <TextField
        className="ruleContainer"
        select
        name="source2_id"
        label="Source"
        variant="outlined"
        size="small"
        // value={inputField.source2_id}
        value={source2_id}
        onChange={(event) => {
          console.log(inputField);
          setSelectedSource2(event.target.value);
          setDefinedValue2(event.target.value);
          handleChangeInput(inputField.id, event);
        }}
      >
        {activeSourceFields
          ? activeSourceFields.map((opt) => (
              <MenuItem key={opt.Source_ID} value={opt.Source_ID}>
                {opt.SourceName_CR}
              </MenuItem>
            ))
          : ""}
      </TextField>

      {definedValue ? (
        <TextField
          className="ruleContainer"
          label="Defined Value"
          name="attribute2_id"
          variant="outlined"
          size="small"
          // value={inputField.attribute2_id}
          value={attribute2_id}
          onChange={(event) => handleChangeInput(inputField.id, event)}
        />
      ) : (
        <TextField
          className="ruleContainer"
          select
          name="attribute2_id"
          label="Attribute"
          variant="outlined"
          size="small"
          // value={inputField.attribute2_id}
          value={attribute2_id}
          onChange={(event) => handleChangeInput(inputField.id, event)}
        >
          {activeFields2
            ? activeFields2.map((opt) => (
                <MenuItem key={opt.Field_ID} value={opt.Field_ID}>
                  {opt.FieldName_CR}
                </MenuItem>
              ))
            : ""}
        </TextField>
      )}
    </>
  );
}

export default SourceInputBox;
